import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { getTandCTypes } from "../../../data/enums";
import logger from "../../../services/logger";
import termsAndConditionsService from "../../../services/termsAndConditionsService";
import BackButton from "../../common/backButton";
import { getDynamicFormJson } from "../../common/dynamicFormService";
import Form from "../../common/form";
import {
  getFormButtonText,
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../../common/formUtils";

class TermsAndConditionForm extends Form {
  constructor() {
    super();
    this.formJson = getDynamicFormJson("termsAndConditions");
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }

  getEnumValue() {
    try {
      const types = getTandCTypes();
      const dropDowns = { ...this.state.dropDowns };
      dropDowns.types = types;

      this.setState({ dropDowns });
    } catch (ex) {
      logger.error("t and c ", ex);
    }
  }

  async populateForm() {
    const id = this.props.match.params.id;
    if (id === "new") return;
    try {
      const { data } = await termsAndConditionsService.get(id);
      this.mapToViewModel(data);
    } catch (ex) {
      logger.error(ex);
    }
  }

  async componentDidMount() {
    await this.populateForm();

    this.getEnumValue();
  }

  doSubmit = async (id) => {
    try {
      if (id === "new") {
        await termsAndConditionsService.create(this.state.data);
      } else {
        await termsAndConditionsService.update(this.state.data);
      }
      this.props.history.push("/configurations/terms-and-conditions");
    } catch (ex) {
      logger.log(ex);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.match.params.id;

    const buttonText = getFormButtonText(id);

    const titleText = getFormTitleText(id, this.formJson.alias);

    return (
      <Card>
          <CardHeader title={t(titleText)} action={<BackButton {...this.props} />} />

        <form onSubmit={(event) => this.handleSubmit(event, id)}>
          {this.renderForm(this.formJson, dropDowns)}

          {/* <CardContent>
            <Grid container item sm={12} md={12} direction="row-reverse">
              {this.renderMatButton(t(buttonText))}
              {this.renderMatButton(t("common:Reset"), "reset", "secondary")}
            </Grid>
          </CardContent> */}
        </form>
      </Card>
    );
  }
}

export default withTranslation(["termsAndConditions", "common"])(
  TermsAndConditionForm
);
